import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { catchError, map, of } from "rxjs";
import { LoginRequest } from "../interfaces/loginRequest.interface";
import { TokenResponse } from "../interfaces/tokenResponse.interface";
import { OrderUser } from "@app/orders/interfaces/order-user.interface";
import { SaveResult } from "@app/shared/interfaces/saveResult.interface";

@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private router: Router) {}

  isAuthenticated() {
    return this.http
      .get<OrderUser>(
        `${environment.apiUrl}/auth/validateToken`,
        this.getAuthHeader()
      )
      .pipe(
        map((user: OrderUser) => {
          return user;
        }),
        catchError(() => {
          return of(null);
        })
      );
  }

  loginRequest(loginRequest: LoginRequest) {
    return this.http.post<TokenResponse>(
      `${environment.apiUrl}/auth/login`,
      loginRequest
    );
  }
  // Function to clear the input fields
  clearInputFields() {
    const usernameInput = document.getElementById('email') as HTMLInputElement;
    const passwordInput = document.getElementById('password') as HTMLInputElement;

    if (usernameInput) {
      usernameInput.value = '';
    }

    if (passwordInput) {
      passwordInput.value = '';
    }
  }


  logOut() {
    sessionStorage.removeItem("ilc_token");
    sessionStorage.clear();
    this.router.navigate([""]);
    this.clearInputFields();
  }

  getAuthHeader() {
    const token = sessionStorage.getItem("ilc_token");

    const headers = new HttpHeaders({
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    });

    return { headers };
  }

  forgotPassword(email: string) {
    return this.http.post(`${environment.apiUrl}/auth/forgotPassword`, {
      email,
    });
  }

  resetPassword(request: { code: string; password: string }) {
    return this.http.post<SaveResult>(
      `${environment.apiUrl}/auth/resetPassword`,
      request
    );
  }
}
